import { createContext, useContext, type ReactNode } from 'react';

const StaticMotionContext = createContext(false);

/**
 * Forces entrance-animation wrappers (`PageTransition` / `StaggerItem`) to render
 * their static, full-opacity form for everything inside.
 *
 * Needed for headless PDF export: the entrance animations tween `opacity: 0 → 1`
 * on mount with a per-index delay, and the print page's readiness signal only
 * watches layout height (which the opacity/transform tween never changes) — so it
 * can flip ready and be captured mid-fade, leaving later items faded or blank.
 * This wins the whole subtree with no per-item prop threading.
 */
export const StaticMotionProvider = ({ children }: { children: ReactNode }) => (
  <StaticMotionContext.Provider value={true}>{children}</StaticMotionContext.Provider>
);

export const useStaticMotion = (): boolean => useContext(StaticMotionContext);
